import $ from "jquery";

(() => {
    const init = () => {
    // Handle gallery button clicks and image clicks
    $(document).on('click', '.nav-box-property__gallery-button, .nav-box-property__gallery-trigger', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const $trigger = $(this);
        const ref = $trigger.data('property-ref');
        const title = $trigger.data('property-title');
        const price = $trigger.data('property-price');
        const link = $trigger.data('property-link');
        const address = $trigger.data('property-address');
        const images = $trigger.data('property-images');
        const beds = $trigger.data('property-beds');
        const baths = $trigger.data('property-baths');
        const area = $trigger.data('property-area');
        
        // Create lightbox HTML
        const lightboxId = 'property-lightbox-' + ref;
        let lightboxHtml = `
            <div id="${lightboxId}" class="property-lightbox-overlay">
                <div class="property-lightbox-container">
                    <button class="property-lightbox-close">&times;</button>
                    <div class="property-lightbox-content">
                        <div class="property-lightbox-gallery">
                            <div class="property-lightbox-main-image">
                                <img src="${images[0].main}" alt="${title}" />
                            </div>
                            ${images.length > 1 ? `
                                <div class="property-lightbox-thumbs">
                                    ${images.map((img, index) => `
                                        <img src="${img.thumb}" 
                                             alt="${title}" 
                                             class="property-lightbox-thumb ${index === 0 ? 'active' : ''}"
                                             data-main="${img.main}"
                                             data-index="${index}" />
                                    `).join('')}
                                </div>
                            ` : ''}
                        </div>
                        <div class="property-lightbox-details">
                            <h3>${title}</h3>
                            <p class="property-lightbox-price">${price}</p>
                            <div class="property-lightbox-address">${address}</div>
                            
                            ${(beds || baths || area) ? `
                                <div class="property-lightbox-features">
                                    <h4>Property Details</h4>
                                    <div class="property-lightbox-features-grid">
                                        ${beds ? `
                                            <div class="property-lightbox-feature">
                                                <i class="fas fa-bed"></i>
                                                <span>${beds} Bedroom${beds != 1 ? 's' : ''}</span>
                                            </div>
                                        ` : ''}
                                        ${baths ? `
                                            <div class="property-lightbox-feature">
                                                <i class="fas fa-bath"></i>
                                                <span>${baths} Bathroom${baths != 1 ? 's' : ''}</span>
                                            </div>
                                        ` : ''}
                                        ${area ? `
                                            <div class="property-lightbox-feature">
                                                <i class="fas fa-ruler-combined"></i>
                                                <span>${area}</span>
                                            </div>
                                        ` : ''}
                                    </div>
                                </div>
                            ` : ''}
                            
                            <a href="${link}" target="_blank" class="property-lightbox-link">
                                Go to Property <i class="fas fa-external-link-alt"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        `;
        
        // Add to body
        $('body').append(lightboxHtml);
        
        // Show lightbox
        $('#' + lightboxId).fadeIn(300);
        
        // Prevent body scroll
        $('body').addClass('lightbox-open');
    });
    
    // Handle lightbox close
    $(document).on('click', '.property-lightbox-close, .property-lightbox-overlay', function(e) {
        if (e.target === this) {
            const $lightbox = $(this).closest('.property-lightbox-overlay');
            $lightbox.fadeOut(300, function() {
                $lightbox.remove();
            });
            $('body').removeClass('lightbox-open');
        }
    });
    
    // Handle thumbnail clicks
    $(document).on('click', '.property-lightbox-thumb', function() {
        const $thumb = $(this);
        const mainSrc = $thumb.data('main');
        
        // Update active thumb
        $thumb.siblings().removeClass('active');
        $thumb.addClass('active');
        
        // Update main image
        $thumb.closest('.property-lightbox-gallery').find('.property-lightbox-main-image img').attr('src', mainSrc);
    });
    
    // Handle escape key
    $(document).on('keydown', function(e) {
        if (e.keyCode === 27 && $('.property-lightbox-overlay').length) {
            $('.property-lightbox-close').click();
        }
    });
    };
    
    // Initialize immediately
    init();
    
    // Re-initialize when new content is loaded
    $(document).on('properties-loaded', init);
})();